import clsx from "clsx";
import * as React from "react";

export const Card = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    return <div className={clsx("flex flex-col pt-6", className)}>{children}</div>;
};
